import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const ArrowDownIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue5db'}</MuiIcon>
    );
}
